

<div class="rating-buttons">
    <button class="rating-button" mat-icon-button (click)="submitLike()"
    [class.selected]="selectedRating === 'like'">
        <mat-icon>thumb_up</mat-icon>
    </button>
    <button class="rating-button" mat-icon-button (click)="submitDislike()"
    [class.selected]="selectedRating === 'dislike'">
        <mat-icon>thumb_down</mat-icon>
    </button>
</div>

<div *ngIf="showFeedbackForm" class="feedback-form">
    <label for="reasonSelect" class="feedback-label">Select Reason</label>
    <mat-select id="reasonSelect" class="reason-select" [(ngModel)]="selectedReason" placeholder="Select Reason">
        <mat-option value="wrong_document">Wrong Source Document</mat-option>
        <mat-option value="incorrect_answer">Didn't provide right answer</mat-option>
        <mat-option value="missing_resource">Missing resource</mat-option>
        <mat-option value="other">Other</mat-option>
    </mat-select>

    <label for="feedbackTextarea" class="feedback-label">Additional Feedback (Optional)</label>
    <textarea id="feedbackTextarea" class="feedback-textarea" [(ngModel)]="additionalFeedback"></textarea>

    <button mat-raised-button color="primary" class="submit-button" (click)="submitFeedback()">SUBMIT</button>
</div>
<div class="contact-info">
    <p>
       Manual Assist can make mistakes. Check important info in manuals.
    </p>
</div>
<div class="contact-info">
    <p>
        If your question was not resolved, please reach out to our Tech Helpline at:
        <a href="tel:+18888783244">888-878-3244</a>
    </p>
</div>